<template>
  <div v-if="getPermission.schedules.view">

    <new-schedule-form ref="NewScheduleForm"/>
    <md-dialog :md-active.sync="showWeeklyCopyModal">
      <md-dialog-title>Weekly Copy</md-dialog-title>
      <md-dialog-content>

        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <label>Week</label>
              <md-input type="number" v-model="weeklyCopyModalData.toWeek"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <label>Year</label>
              <md-input type="number" v-model="weeklyCopyModalData.toYear"/>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter" style="margin: 8px">
          <div class="md-layout-item md-size-100 md-small-size-100">
            <h4>Copy to {{getWeekCopyDurationDisplay}}</h4>
          </div>
        </div>
        <md-checkbox v-model="weeklyCopyModalData.dontCopyAdditionalPickup">
          Don't copy additional pickup
        </md-checkbox>
        <md-checkbox v-model="weeklyCopyModalData.copyOnlyOneSchedulePerStore">
          Copy only one schelude per store
        </md-checkbox>

        <h4>Schedules to copy</h4>
        <table>
          <tr>
            <th>Store</th>
            <th>ETA-Plan</th>
            <th>Pickup Count</th>
            <th>New ETA-Plan</th>
          </tr>
          <tr :key="s.id" v-for="s in getSchedulesToCopy">
            <td>{{s.storeId}}</td>
            <td>{{s.etaPlan | date}}</td>
            <td>{{s.pickupCounter}}</td>
            <td>{{getNewEtaForWeeklyCopy(s) | date}}</td>
          </tr>
        </table>

      </md-dialog-content>

      <calling-api :paths="['/api/w/schedules/save']">
        <md-dialog-actions>
          <md-button class="md-primary" @click="showWeeklyCopyModal = false">Close</md-button>
          <md-button @click="doWeeklyCopy" class="md-primary">Save</md-button>
        </md-dialog-actions>
      </calling-api>
    </md-dialog>

    <md-card class="searchPanel">

      <md-card-expand>
        <md-card-expand-content>
          <md-card-content>
            <calling-api path="/api/w/stores">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field>
                        <label>Week/Year</label>
                        <md-input v-model="input.weekAndYearFrom" @keyup.enter="doSearch"/>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field>
                        <label>To</label>
                        <md-input v-model="input.weekAndYearTo" @keyup.enter="doSearch"/>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <datepicker v-model="searchRequest.etaPlanStart">
                        <label>ETA Plan</label>
                      </datepicker>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <datepicker v-model="searchRequest.etaPlanEnd">
                        <label>To</label>
                      </datepicker>
                    </div>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <datepicker v-model="searchRequest.etaAssignedStart">
                        <label>ETA Assigned</label>
                      </datepicker>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <datepicker v-model="searchRequest.etaAssignedEnd">
                        <label>To</label>
                      </datepicker>
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-size-70 md-small-size-100">

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-33 md-small-size-100">
                      <auto-complete-master-data-multiple-select
                              ref="SelectDriverGroup"
                              :prepared-options="getDriverGroupOptionsForUser"
                              :multiple="true"
                              :init-selected-ids="searchRequest.driverGroups"
                              label="Driver Group"
                              :on-selected-item-ids-changed="handleDriverRegionsChanged">
                      </auto-complete-master-data-multiple-select>
                    </div>
                    <div class="md-layout-item md-size-33 md-small-size-100">

                      <auto-complete-search-store-multiple-select
                              ref="SelectStore"
                              multiple="true"
                              label="Store"
                              :join-end-outlets="true"
                              :init-selected-ids="searchRequest.storeIds"
                              :on-selected-item-ids-changed="handleStoresChanged">
                      </auto-complete-search-store-multiple-select>

                    </div>

                    <div class="md-layout-item md-size-33 md-small-size-100">
                      <master-data-select
                              label="Schedule Status"
                              :options="scheduleStatusOptions"
                              v-model="searchRequest.status"
                      />
                    </div>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-33 md-small-size-100">
                      <auto-complete-master-data-multiple-select
                              ref="SelectEndOutlet"
                              group="EndOutlet"
                              label="End outlet"
                              :init-selected-ids="searchRequest.endOutlets"
                              :on-selected-item-ids-changed="handleEndOutletsChanged">
                      </auto-complete-master-data-multiple-select>
                    </div>
                    <div class="md-layout-item md-size-33 md-small-size-100">
                      <auto-complete-master-data-multiple-select
                              ref="SelectHauler"
                              group="Hauler"
                              label="Hauler"
                              :init-selected-ids="searchRequest.haulers"
                              :on-selected-item-ids-changed="handleHaulersChanged">
                      </auto-complete-master-data-multiple-select>
                    </div>
                    <div class="md-layout-item md-size-33 md-small-size-100">
                      <div v-if="drivers">
                        <auto-complete-master-data-select
                                display-type="idOnly"
                                label="Driver"
                                :prepared-options="drivers"
                                :init-value-id="searchRequest.driverId"
                                :on-item-changed="handleSearchDriverChanged">
                        </auto-complete-master-data-select>
                      </div>
                    </div>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-100">
                      <md-card-actions>
                        <calling-api path="/api/w/schedules">
                          <md-button @click="doSearch" class="btn-search-schedule md-primary md-raised">Search</md-button>
                          <md-button @click="clearSearch" class="md-raised">Clear</md-button>
                        </calling-api>
                      </md-card-actions>
                    </div>
                  </div>

                </div>
              </div>
            </calling-api>

          </md-card-content>
        </md-card-expand-content>

        <md-card-actions md-alignment="space-between">
          <div>
            <calling-api :paths="['/api/w/schedules/save','/api/w/schedules/assignLoad','/api/w/schedules/unAssignLoad','/api/w/excel/generate','/api/w/users','/api/w/schedules']">
              <md-button class="md-raised" @click="doNew">New</md-button>
              <md-button v-if="getPermission.schedules.edit"
                         :disabled="!canDoAdditionalPickup"
                         class="md-raised md-primary"
                         @click="doAdditionalPickup">Additional Pickup
              </md-button>
              <md-button v-if="getPermission.schedules.edit"
                         :disabled="!canWeeklyCopy" class="md-raised md-primary"
                         @click="toggleWeeklyCopy">Weekly Copy
              </md-button>
              <md-button v-if="getPermission.schedules.edit"
                         :disabled="!canSave" class="md-raised md-primary"
                         @click="doSaveChangedSchedules">Save
              </md-button>
              <md-button v-if="getPermission.schedules.edit"
                         :disabled="!canAssignNewLoad"
                         class="md-raised md-primary"
                         @click="doAssignLoad">Generate Load ID
              </md-button>
              <md-button v-if="getPermission.schedules.edit"
                         :disabled="!canUnAssignLoadId"
                         class="md-raised md-primary"
                         @click="doUnAssignLoadId">Unassign Load ID
              </md-button>
              <md-button v-if="getPermission.schedules.edit"
                         :disabled="!canDelete"
                         class="md-raised md-accent"
                         @click="doDelete">Delete
              </md-button>
              <md-button v-if="schedules.length > 0" class="md-raised" @click="doDownloadExcel">Download</md-button>
            </calling-api>
          </div>
          <md-card-expand-trigger>
            <md-button class="md-icon-button" id="expand-button">
              <md-icon>keyboard_arrow_down</md-icon>
            </md-button>
          </md-card-expand-trigger>
        </md-card-actions>
      </md-card-expand>


    </md-card>

    <pagination :items="getSchedulesToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2" v-if="getPermission.schedules.edit">
                      <md-checkbox v-model="allItemsSelected" @change="handleAllItemSelectedChanged"/>
                    </th>
                    <th class="header-cell w3">
                      <sort :sort.sync="sort" field="driverGroup">
                        Driver<br/>Group
                      </sort>
                    </th>
                    <th class="header-cell w3">
                      <sort :sort.sync="sort" field="store.name">
                        Store
                      </sort>
                    </th>
                    <th class="header-cell w4">Pickup<br/>Type</th>
                    <th class="header-cell w4">Pickup<br/>Days</th>
                    <th class="header-cell w2-5">Pickup<br/>Count</th>
                    <th class="header-cell w4">Store<br/>Status</th>
                    <th class="header-cell w5">City</th>
                    <th class="header-cell w3">State</th>
                    <th class="header-cell w12">End Outlet</th>
                    <th class="header-cell w6">
                      <sort :sort.sync="sort" field="rawEtaPlan">
                        ETA-Plan
                      </sort>
                    </th>
                    <th class="header-cell w6">
                      <sort :sort.sync="sort" field="rawEtaAssigned">
                        ETA-Assigned
                      </sort>
                    </th>
                    <th class="header-cell w4">Week/Year</th>
                    <th class="header-cell w8">Driver</th>
                    <th class="header-cell w6">Load Id Assigned</th>
                    <th class="header-cell w6">Load Id Used</th>
                    <th class="header-cell w6">Load Id Linked</th>
                    <th class="header-cell w6">BOL Number</th>
                    <th class="header-cell w4">Pickup<br/>Date</th>
                    <th class="header-cell w3">Pickup<br/>Time</th>
                    <th class="header-cell w5">Bales<br/>Picked</th>
                    <th class="header-cell w5">Bales<br/>Left</th>
                    <th class="header-cell w5">BOL<br/>Weight</th>
                    <th class="header-cell w5">Load<br/>Weight</th>
                    <th class="header-cell w5">Schedule<br/>Status</th>
                    <th class="header-cell w5">HAULER</th>
                    <th class="header-cell w5">Format</th>
                    <th class="header-cell w3">Driver<br/>Region</th>
                    <th class="header-cell w5">Create Person</th>
                    <th class="header-cell w5">Create Date</th>
                    <th class="header-cell w5">Create Time</th>
                    <th class="header-cell w5">Change Person</th>
                    <th class="header-cell w5">Change Date</th>
                    <th class="header-cell w5">Change Time</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr :key="item.id" v-for="item in pageItems" :class="getClassForScheduleRow(item)">
                    <td class="body-cell w2" v-if="getPermission.schedules.edit">
                      <md-checkbox v-model="item.selected">
                        <span v-if="hasBeenChanged(item)">*</span>
                      </md-checkbox>
                    </td>
                    <td class="body-cell w3">{{item.driverGroup}}</td>
                    <td class="body-cell w3">
                      {{item.storeId}}
                    </td>
                    <td class="body-cell w4">
                      <master-data-display group="PickupType" :tag-id="item.pickUpTypeId"/>
                    </td>
                    <td class="body-cell w4">{{getDaysDisplay(item)}}</td>
                    <td class="body-cell w2-5">{{item.pickupCounter}}</td>
                    <td class="body-cell w4">
                      <template v-if="item.store && item.store.storeSpecial">{{item.store.storeSpecial.statusName}}
                      </template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.store">
                        {{item.store.city}}
                      </template>
                      <template v-if="item.transloadingInfo">
                        {{item.transloadingInfo.yardCity}}
                      </template>
                    </td>
                    <td class="body-cell w3">
                      <template v-if="item.store">
                        {{item.store.state}}
                      </template>
                      <template v-if="item.transloadingInfo">
                        {{item.transloadingInfo.yardRegion}}
                      </template>
                    </td>
                    <td class="body-cell w12">
                      <template v-if="item.loadIdAssigned || !getPermission.schedules.edit">
                        <master-data-display group="EndOutlet" :tag-id="item.endOutletId"></master-data-display>
                      </template>
                      <auto-complete-master-data-select
                          v-else
                          group="EndOutlet"
                          :prepared-options="getEndOutletOptionsForSchedule(item)"
                          :init-value-id="item.endOutletId"
                          :on-item-changed="handleScheduleEndOutletChanged(item)">
                      </auto-complete-master-data-select>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.billOfLoad || !getPermission.schedules.edit">
                        {{item.etaPlan | date}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-input @keyup="handleEtaPlanStringChanged(item)" v-model="item.etaPlanString"/>
                        </md-field>
                        <span class="md-error" v-if="isDateInvalid(item.etaPlanString)">Invalid format</span>
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.billOfLoad || !getPermission.schedules.edit">
                        {{item.etaAssignedString}}
                      </template>
                      <template v-else>
                        <md-field>
                          <md-input @keyup="handleEtaAssignedStringChanged(item)" v-model="item.etaAssignedString"/>
                        </md-field>
                        <span class="md-error" v-if="isDateInvalid(item.etaAssignedString)">Invalid format</span>
                        <!--<template v-else>-->
                        <!--<span class="md-error" v-if="isEtaAssignInvalid(item)">Et-Assigned must be same week</span>-->
                        <!--</template>-->
                      </template>
                    </td>
                    <td class="body-cell w4">{{item.weekAndYear}}</td>
                    <td class="body-cell w8">
                      <template v-if="item.billOfLoad || !getPermission.schedules.edit">
                        <template v-if="item.driver">{{item.driver.name}}</template>
                        ({{item.driverId}})
                      </template>
                      <template v-else>
                        <div style="min-width:160px" v-if="drivers">
                          <auto-complete-master-data-select
                                  display-type="idOnly"
                                  :prepared-options="drivers"
                                  :init-value-id="item.driverId"
                                  :watch-value-id="item.newDriverId"
                                  :on-item-changed="handleDriverChanged(item)">
                          </auto-complete-master-data-select>
                        </div>
                      </template>
                    </td>
                    <td class="body-cell w6">{{item.loadIdAssigned}}</td>
                    <td class="body-cell w6">{{item.loadIdUsed}}</td>
                    <td class="body-cell w6">{{item.loadIdLinked}}</td>
                    <td class="body-cell w6">
                      <template v-if="item.billOfLoad">{{item.billOfLoad.id}}</template>
                    </td>
                    <td class="body-cell w4">
                      <template v-if="item.billOfLoad" class="td-80">{{item.billOfLoad.pickUpDate | date}}</template>
                    </td>
                    <td class="body-cell w3">
                      <template v-if="item.billOfLoad">{{item.billOfLoad.pickUpDate | time}}</template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.billOfLoad">{{item.billOfLoad.balePicked}}</template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.billOfLoad">{{item.billOfLoad.baleLeft}}</template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.billOfLoad">{{item.billOfLoad.bolWeight | withComma}}</template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.load">{{item.load.totalWeight | withComma}}</template>
                    </td>
                    <td class="body-cell w5">
                      {{item.status}}
                    </td>
                    <td class="body-cell w5">
                      <master-data-display group="Hauler" :tag-id="item.haulerId"/>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.store">
                        {{item.store.industryName}}
                      </template>
                    </td>
                    <td class="body-cell w3">
                      <template v-if="item.store">
                        {{item.store.region}}
                      </template>
                    </td>
                    <td class="body-cell w5">
                      {{item.createPerson}}
                    </td>
                    <td class="body-cell w5">
                      {{item.createDateTime | date}}
                    </td>
                    <td class="body-cell w5">
                      {{item.createDateTime | time}}
                    </td>
                    <td class="body-cell w5">
                      {{item.changePerson}}
                    </td>
                    <td class="body-cell w5">
                      {{item.changeDateTime | date}}
                    </td>
                    <td class="body-cell w5">
                      {{item.changeDateTime | time}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>

  </div>
</template>

<style scoped>
  .schedule-unassigned {
    background: #eea3ac;
  }

  .schedule-row {
    background: white;
  }
</style>

<script>
  import { mapGetters } from 'vuex';
  import toGenerateExcelRequest from '../utils/excel';
  import validateDate from '../utils/validate-date';
  import { sortList } from '../utils/sort';
  import NewScheduleForm from '../components/NewScheduleForm.vue';
  import dateFormat from '../utils/dateFormat';

  const getInitSearchRequest = () => ({
    weekStart: null,
    yearStart: null,
    weekEnd: null,
    yearEnd: null,
    etaPlanStart: null,
    etaPlanEnd: null,
    etaAssignedStart: null,
    etaAssignedEnd: null,
    callDateStart: null,
    callDateEnd: null,
    driverGroups: [],
    pickupTypes: [],
    storeIds: [],
    formats: [],
    haulers: [],
    endOutlets: [],
    status: null,
    driverId: null,
  });

  export default {
    data: () => ({
      scheduleStatusOptions: [
        {
          id: 'NA',
          name: 'NA',
        },
        {
          id: 'P',
          name: 'Partial',
        },
        {
          id: 'C',
          name: 'Completed',
        },
      ],
      searchRequest: getInitSearchRequest(),
      input: {
        weekAndYearFrom: null,
        weekAndYearTo: null,
      },
      schedules: [],
      stores: [],
      drivers: null,
      allItemsSelected: false,
      showWeeklyCopyModal: false,
      weeklyCopyModalData: {
        toYear: null,
        toWeek: null,
        dontCopyAdditionalPickup: false,
        copyOnlyOneSchedulePerStore: false,
      },
      sort: {
        field: `driverGroup`,
        ascending: true,
      },
    }),
    computed: {
      ...mapGetters([
        'getDriverGroupOptionsForUser',
        'getSchedules',
        'getRole',
        'getMasterDataName',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
      ]),
      getSchedulesToDisplay() {
        return _(this.schedules)
          .chain()
          .groupBy(it => it.weekAndYear)
          .map((schedules, weekAndYear) => ({
            schedules,
            weekAndYear,
          }))
          .sortBy((it) => {
            const split = it.weekAndYear.split('/');
            return `${split[1]}${split[0]}`;
          })
          .reverse()
          .map(({ schedules }) => sortList(schedules, this.sort))
          .flatten()
          .value();
        // return sortList(this.schedules, this.sort);
      },
      selectedSchedules() {
        return _(this.schedules)
          .filter(it => it.selected);
      },
      hasChangedItem() {
        return !!_(this.schedules)
          .find(it => this.hasBeenChanged(it) === true);
      },
      canWeeklyCopy() {
        if (!this.getPermission.schedules.edit) {
          return false;
        }
        if (this.selectedSchedules.length === 0) {
          return false;
        }

        const weekAndYears = _.chain(this.selectedSchedules)
          .map(it => it.weekAndYear)
          .uniq()
          .value();

        if (weekAndYears.length > 1) {
          return false;
        }

        return true;
      },
      canSave() {
        if (!this.getPermission.schedules.edit) {
          return false;
        }
        return this.hasChangedItem;
      },
      canDoAdditionalPickup() {
        if (!this.getPermission.schedules.edit) {
          return false;
        }
        if (this.selectedSchedules.length !== 1) {
          return false;
        }
        const hasLinkedLoadId = !!_(this.selectedSchedules)
          .find(it => !!it.linkedLoadId);
        const hasMk2Schedule = !!_(this.selectedSchedules)
          .find(it => !it.linkedLoadId && it.storeId.length > 4);

        console.log(`hasLinkedLoadId=${hasLinkedLoadId} hasMk2Schedule=${hasMk2Schedule}`);

        if (hasLinkedLoadId || hasMk2Schedule) {
          return false;
        }

        const item = this.selectedSchedules[0];

        const addtionalPickUpItem = _(this.getSchedules)
          .find(it =>
            it.id !== item.id
            && it.storeId === item.storeId
            && it.etaPlan === item.etaPlan
            && !it.billOfLoad);

        console.log(`addtionalPickUpItem=${JSON.stringify(addtionalPickUpItem)}`);

        if (addtionalPickUpItem) {
          return false;
        }

        console.log(`item.status = ${item.status}`);

        return item.status === 'P' && !!item.billOfLoad;
      },
      canAssignNewLoad() {
        if (!this.getPermission.schedules.edit) {
          return false;
        }
        if (this.selectedSchedules.length === 0) {
          return false;
        }
        if (_(this.selectedSchedules)
          .find(it => !it.etaAssigned || !it.driverId || it.driverId === "null")) {
          return false;
        }
        if (_(this.selectedSchedules)
          .find(it => !!it.loadIdAssigned || !!it.billOfLoad)) {
          return false;
        }
        if (_(this.selectedSchedules)
          .find((it) => {
            const status = _(it)
              .lookup('store.storeSpecial.statusId');
            return status === 'B' || status === 'ZS01';
          })) {
          return false;
        }

        const allEtaAssignedSame = _(this.selectedSchedules)
          .chain()
          .map(it => moment(it.etaAssigned)
            .format('YYYYMMDD'))
          .uniq()
          .value()
          .length === 1;

        const allDriverIdSame = _(this.selectedSchedules)
          .chain()
          .map(it => it.driverId)
          .uniq()
          .value()
          .length === 1;

        const allEndOutletSame = _(this.selectedSchedules)
          .chain()
          .map(it => it.endOutletId)
          .uniq()
          .value()
          .length === 1;
        const hasLinkedLoadId = !!_(this.selectedSchedules)
          .find(it => !!it.linkedLoadId);
        const hasMk2Schedule = !!_(this.selectedSchedules)
          .find(it => !it.linkedLoadId && it.storeId.length > 4);
        if (hasLinkedLoadId) {
          return this.selectedSchedules.length === 1;
        }
        if (hasMk2Schedule) {
          return this.selectedSchedules.length === 1;
        }

        return allEtaAssignedSame && allDriverIdSame && allEndOutletSame;
      },
      canDelete() {
        return this.selectedSchedules.length > 0 && !_(this.selectedSchedules)
          .find(it => !!it.billOfLoad || !!it.loadIdAssigned);
      },
      canUnAssignLoadId() {
        return this.selectedSchedules.length > 0 && _(this.selectedSchedules)
          .filter(it => !!it.loadIdAssigned && !it.loadIdUsed).length === this.selectedSchedules.length;
      },
      getWeekCopyDurationDisplay() {
        if (this.weeklyCopyModalData.toYear && this.weeklyCopyModalData.toWeek) {
          const m = moment()
            .startOf('d')
            .year(this.weeklyCopyModalData.toYear)
            .week(this.weeklyCopyModalData.toWeek);

          // if (m.isBefore(moment()
          //   .startOf('w')
          //   .add(1, 'w'))) {
          //   return `Can only copy to future weeks.`;
          // }

          return `${m.startOf('w')
            .format('MM/DD/YYYY')} ~ ${m.endOf('w')
            .format('MM/DD/YYYY')}`;
        }
        return '';
      },
      // isWeekCopyDurationValid() {
      //   if (this.weeklyCopyModalData.toYear && this.weeklyCopyModalData.toWeek) {
      //     const m = moment()
      //       .startOf('d')
      //       .year(this.weeklyCopyModalData.toYear)
      //       .week(this.weeklyCopyModalData.toWeek);
      //
      //     return m.isAfter(moment()
      //       .startOf('w')
      //       .add(1, 'w'));
      //   }
      //   return false;
      // },
      getSchedulesToCopy() {
        let schedules = this.selectedSchedules;
        if (this.weeklyCopyModalData.dontCopyAdditionalPickup === true) {
          schedules = schedules.filter(it => it.pickupCounter === 1);
        }
        if (this.weeklyCopyModalData.copyOnlyOneSchedulePerStore === true) {
          schedules = _(schedules)
            .uniq(it => it.storeId);
        }
        return schedules;
      },
    },
    watch: {
      getSchedules(val) {
        this.updateCachedSchedules(val);
      },
      'input.weekAndYearFrom': function (val) {
        if (val && val.length > 0) {
          const split = val.split("/");
          try {
            this.searchRequest.weekStart = parseInt(split[0], 0);
            this.searchRequest.yearStart = split[1] ? parseInt(split[1], 0) : null;
          } catch (e) {
            this.searchRequest.yearStart = null;
            this.searchRequest.weekStart = null;
          }
        } else {
          this.searchRequest.yearStart = null;
          this.searchRequest.weekStart = null;
        }
      },
      'input.weekAndYearTo': function (val) {
        if (val && val.length > 0) {
          const split = val.split("/");
          try {
            this.searchRequest.weekEnd = parseInt(split[0], 0);
            this.searchRequest.yearEnd = split[1] ? parseInt(split[1], 0) : null;
          } catch (e) {
            this.searchRequest.yearEnd = null;
            this.searchRequest.weekEnd = null;
          }
        } else {
          this.searchRequest.yearEnd = null;
          this.searchRequest.weekEnd = null;
        }
      },
    },
    components: {
      NewScheduleForm,
    },
    mounted() {
      this.$el.querySelector('#expand-button')
        .click();

      this.updateCachedSchedules(this.getSchedules);

      this.drivers = null;
      this.$store.dispatch('getUsersByCategory', { category: 'A' })
        .then((res) => {
          this.drivers = res;
        });

      const cachedSearchRequest = this.$store.state.schedule.searchRequest;
      if (cachedSearchRequest && !_(cachedSearchRequest)
        .isEmpty()) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
        if (!cachedSearchRequest.driverGroups) { // migrate from old version search
          this.searchRequest = getInitSearchRequest();
        }
        const {
          weekStart, weekEnd, yearStart, yearEnd,
        } = this.searchRequest;
        let weekAndYearFrom = '';
        if (weekStart) {
          weekAndYearFrom = `${weekStart}`;
        }
        if (yearStart) {
          weekAndYearFrom += `/${yearStart}`;
        }
        this.input.weekAndYearFrom = weekAndYearFrom;

        let weekAndYearTo = '';
        if (weekEnd) {
          weekAndYearTo = `${weekEnd}`;
        }
        if (yearEnd) {
          weekAndYearTo += `/${yearEnd}`;
        }
        this.input.weekAndYearTo = weekAndYearTo;
      }
    },
    methods: {
      isDateInvalid(dateString) {
        if (validateDate(dateString)) {
          return false;
        }
        return true;
      },
      isEtaAssignInvalid(item) {
        return moment(item.etaPlan)
          .week() !== moment(item.etaAssignedString)
          .week();
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      handleSearchStore(term) {
        console.log(`handleSearchStore`, term);
        return new Promise((resolve) => {
          resolve([
            {
              id: "foo",
              name: term,
            },
          ]);
        });
      },
      updateCachedSchedules(sourceSchedules) {
        this.allItemsSelected = false;
        const schedules = JSON.parse(JSON.stringify(sourceSchedules));
        _(schedules)
          .each((it) => {
            it.selected = false;
            it.newDriverId = null;
            it.etaAssignedString = moment(it.etaAssigned)
              .format('M/D/YYYY');
            it.etaPlanString = moment(it.etaPlan)
              .format('M/D/YYYY');
            it.rawEtaAssigned = it.etaAssigned;
            it.rawEtaPlan = it.etaPlan;
          });

        // use nextTick to force refresh the list to prevent ui not render correctly
        this.schedules = [];
        this.$nextTick(() => {
          this.schedules = schedules;
        });
      },
      hasBeenChanged(schedule) {
        const lhs = _(this.getSchedules)
          .find(it => it.id === schedule.id);
        return (schedule.newDriverId && lhs.driverId !== schedule.newDriverId)
          || (schedule.endOutletId && lhs.endOutletId !== schedule.endOutletId)
          || schedule.etaAssignedString !== moment(lhs.etaAssigned)
            .format('M/D/YYYY')
          || schedule.etaPlanString !== moment(lhs.etaPlan)
            .format('M/D/YYYY');
      },
      handleDriverRegionsChanged(ids) {
        this.searchRequest.driverGroups = ids;
      },
      handlePickupTypesChanged(ids) {
        this.searchRequest.pickupTypes = ids;
      },
      handleStoresChanged(ids) {
        this.searchRequest.storeIds = ids;
      },
      handleIndustriesChanged(ids) {
        this.searchRequest.formats = ids;
      },
      handleHaulersChanged(ids) {
        this.searchRequest.haulers = ids;
      },
      handleEndOutletsChanged(ids) {
        this.searchRequest.endOutlets = ids;
      },
      handleDriverChanged(item) {
        return (id) => {
          item.newDriverId = id;

          if (item.loadIdAssigned) {
            _(this.schedules)
              .chain()
              .filter(it => it.loadIdAssigned === item.loadIdAssigned)
              .each((s) => {
                s.newDriverId = id;
              });
          }
        };
      },
      handleEtaAssignedStringChanged(item) {
        item.etaAssigned = moment(item.etaAssignedString, 'M/D/YYYY')
          .toDate();
        if (item.loadIdAssigned) {
          _(this.schedules)
            .chain()
            .filter(it => it.loadIdAssigned === item.loadIdAssigned)
            .each((s) => {
              s.etaAssignedString = item.etaAssignedString;
              s.etaAssigned = item.etaAssigned;
            });
        }
      },
      handleEtaPlanStringChanged(item) {
        item.etaPlan = moment(item.etaPlanString, 'M/D/YYYY')
          .toDate();
        if (item.loadIdAssigned) {
          _(this.schedules)
            .chain()
            .filter(it => it.loadIdAssigned === item.loadIdAssigned)
            .each((s) => {
              s.etaPlanString = item.etaPlanString;
              s.etaPlan = item.etaPlan;
            });
        }
      },
      doAdditionalPickup() {
        const requests = _(this.selectedSchedules)
          .chain()
          .map(it => ({
            storeId: it.storeId,
            driverId: it.driverId,
            scheduleId: it.id,
            action: 'ADDITIONAL_PICKUP',
          }))
          .value();
        console.log(JSON.stringify(requests));
        this.$store.dispatch('saveSchedules', requests)
          .then(() => {
            this.doSearch();
          });
      },
      doSaveChangedSchedules() {
        const changedItems = _(this.schedules)
          .filter(it => this.hasBeenChanged(it));
        if (_(changedItems)
          .find(it => moment(it.etaAssigned)
            .isBefore(moment()
              .startOf('day')))) {
          window.alert('ETA-Assigned must not before today.');
          return;
        }
        if (_(changedItems)
          .find(it => this.isDateInvalid(it.etaAssignedString))) {
          window.alert('ETA-Assigned is invalid.');
          return;
        }
        if (_(changedItems)
          .find(it => this.isDateInvalid(it.etaPlanString))) {
          window.alert('ETA-Plan is invalid.');
          return;
        }
        // if (_(changedItems).find(it => this.isEtaAssignInvalid(it))) {
        //   window.alert('ETA-Assigned is invalid.');
        //   return;
        // }

        const requests = _(changedItems)
          .chain()
          .map(it => ({
            storeId: it.storeId,
            driverId: it.driverId,
            newDriverId: it.newDriverId,
            etaPlan: it.etaPlan,
            etaAssigned: it.etaAssigned,
            scheduleId: it.id,
            endOutletId: it.endOutletId,
            action: 'UPDATE',
          }))
          .value();
        console.log(JSON.stringify(requests));
        this.$store.dispatch('saveSchedules', requests)
          .then(() => {
            this.doSearch();
          });
      },
      toggleWeeklyCopy() {
        const weekAndYear = _.chain(this.selectedSchedules)
          .map(it => it.weekAndYear)
          .uniq()
          .first()
          .value();
        console.log(`weekAndYear=${weekAndYear}`);
        const split = weekAndYear.split('/');
        const w = parseInt(split[0], 0);
        const y = parseInt(split[1], 0);
        const m = moment()
          .startOf('d')
          .year(y)
          .week(w)
          .add(1, 'w');

        this.weeklyCopyModalData.dontCopyAdditionalPickup = false;
        this.weeklyCopyModalData.copyOnlyOneSchedulePerStore = false;
        this.weeklyCopyModalData.toWeek = m.week();
        this.weeklyCopyModalData.toYear = m.year();
        this.showWeeklyCopyModal = true;
      },
      doWeeklyCopy() {
        const requests = _(this.getSchedulesToCopy)
          .map(it => ({
            storeId: it.storeId,
            driverId: it.driverId,
            scheduleId: it.id,
            copyToWeek: this.weeklyCopyModalData.toWeek,
            copyToYear: this.weeklyCopyModalData.toYear,
            pickupCounter: it.pickupCounter,
            action: 'WEEKLY_COPY',
          }));

        console.log(JSON.stringify(requests));
        this.$store.dispatch('saveSchedules', requests)
          .then(() => {
            this.showWeeklyCopyModal = false;
            this.doSearch();
          });
      },
      doAssignLoad() {
        const request = {
          driverId: _(this.selectedSchedules)
            .chain()
            .pluck('driverId')
            .uniq()
            .first()
            .value(),
          scheduleIds: _(this.selectedSchedules)
            .pluck('id'),
        };
        console.log(JSON.stringify(request));
        this.$store.dispatch('assignLoadIds', request)
          .then(() => {
            this.doSearch();
          });
      },
      doDelete() {
        if (!window.confirm('Delete Selceted Items?')) {
          return;
        }
        const requests = _(this.selectedSchedules)
          .chain()
          .map(it => ({
            storeId: it.storeId,
            driverId: it.driverId,
            scheduleId: it.id,
            delete: true,
            action: 'DELETE',
          }))
          .value();
        console.log(JSON.stringify(requests));
        this.$store.dispatch('saveSchedules', requests)
          .then(() => {
            this.doSearch();
          });
      },
      doUnAssignLoadId() {
        Promise.all(_(this.selectedSchedules)
          .map((it) => {
            const req = {
              driverId: it.driverId,
              loadId: it.loadIdAssigned,
            };
            return this.$store.dispatch('unAssignLoadId', req);
          }))
          .then(this.doSearch);
      },
      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Schedules.xls',
          1,
        );

        request.rows = _(this.getSchedulesToDisplay)
          .map(item => [
            item.driverGroup,
            item.storeId,
            this.getMasterDataName('PickupType', item.pickUpTypeId),
            this.getDaysDisplay(item),
            item.pickupCounter,
            _(item)
              .lookup('store.storeSpecial.statusName'),
            _(item)
              .lookup('store.city') || _(item)
              .lookup('transloadingInfo.yardCity'),
            _(item)
              .lookup('store.state') || _(item)
              .lookup('transloadingInfo.yardRegion'),
            dateFormat.date(item.etaPlan),
            dateFormat.date(item.etaAssigned),
            item.weekAndYear,
            item.driverId,
            item.loadIdAssigned,
            item.loadIdUsed,
            item.loadIdLinked,
            _(item)
              .lookup('billOfLoad.id'),
            dateFormat.date(_(item)
              .lookup('billOfLoad.pickUpDate')),
            dateFormat.time(_(item)
              .lookup('billOfLoad.pickUpDate')),
            _(item)
              .lookup('billOfLoad.balePicked'),
            _(item)
              .lookup('billOfLoad.baleLeft'),
            _(item)
              .lookup('billOfLoad.bolWeight'),
            _(item)
              .lookup('load.totalWeight'),
            item.status,
            this.getMasterDataName('EndOutlet', item.endOutletId),
            this.getMasterDataName('Hauler', item.haulerId),
            _(item)
              .lookup('store.industryName'),
            _(item)
              .lookup('store.region'),
            item.createPerson,
            dateFormat.date(item.createDateTime),
            dateFormat.time(item.createDateTime),
            item.changePerson,
            dateFormat.date(item.changeDateTime),
            dateFormat.time(item.changeDateTime),
          ]);

        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },
      doSearch() {
        if (this.searchRequest.driverGroups.length === 0) {
          window.alert("Driver Group is required to perform serach.");
          return;
        }
        console.log(JSON.stringify(this.searchRequest));
        this.$store.dispatch('loadSchedules', this.searchRequest)
          .then(() => {
            if (this.$el.querySelector('.searchPanel.md-expand-active')) {
              this.$el.querySelector('#expand-button')
                .click();
            }
          });
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
          });
        this.$refs.SelectDriverGroup.clear();
        this.$refs.SelectStore.clear();
        this.$refs.SelectHauler.clear();
        this.$refs.SelectEndOutlet.clear();
        this.input.weekAndYearFrom = null;
        this.input.weekAndYearTo = null;
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest();
        });
      },
      handleAllItemSelectedChanged() {
        _(this.schedules)
          .each((it) => {
            it.selected = this.allItemsSelected;
          });
      },
      doNew() {
        this.$refs.NewScheduleForm.openDialog();
      },
      handleSearchDriverChanged(id) {
        this.searchRequest.driverId = id;
      },
      getDaysDisplay(schedule) {
        const days = _(schedule)
          .lookup('store.storeSpecial.days');
        if (days) {
          return _(days)
            .map(it => dateFormat.weekDayDisplay(it))
            .join(',');
        }
        return '';
      },
      getEndOutletOptionsForSchedule(schedule) {
        const allEndOutlets = this.getMasterDataAsSelectOptionByGroup('EndOutlet');
        const endOutletIds = _(schedule)
          .lookup('store.storeSpecial.endOutletIds') || [];
        return _(allEndOutlets)
          .filter(it => _(endOutletIds)
            .contains(it.id));
      },
      handleScheduleEndOutletChanged(schedule) {
        return (id) => {
          schedule.endOutletId = id;
        };
      },
      getClassForScheduleRow(schedule) {
        if (!schedule.loadIdAssigned) {
          return {
            'schedule-unassigned': true,
          };
        }
        return {
          'schedule-row': true,
        };
      },
      getNewEtaForWeeklyCopy(schedule) {
        const oldEtaMoment = moment(schedule.etaPlan);
        if (this.weeklyCopyModalData.toYear && this.weeklyCopyModalData.toWeek) {
          return moment()
            .startOf('d')
            .year(this.weeklyCopyModalData.toYear)
            .week(this.weeklyCopyModalData.toWeek)
            .day(oldEtaMoment.day())
            .toDate();
        }
        return null;
      },
    },
  };

</script>
